import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcherFactory } from '@dataroom/json-rpc-dispatcher';
import DITypes from '@dataroom/json-rpc-dispatcher/DITypes';

@injectable()
class FollowRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcherFactory,
  ) {}

  follow = async (payload: { dataroomId: number }): Promise<void> => {
    const req = new Request('dataroom.restricted.follow', payload);
    await this.rpc().call<RpcSuccess>(req);
  };

  unfollow = async (payload: { dataroomId: number }): Promise<{ success: boolean }> => {
    const request = new Request('dataroom.unfollow', payload);
    const response = await this.rpc().call<RpcSuccess>(request);

    return response.getResult() as any;
  };
}

export default FollowRepository;
